import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import styles from "./sticky-btn.module.scss";

const StickyBtn = ({openModal}) => {

  return (
    <div onClick={(e) => openModal(e)} className={styles.sticky_btn}>
      <FontAwesomeIcon
        icon={solid("user-plus")}
        size="2x"
        className={styles.row_icon}
        color="#fff"
      />
    </div>
  );
};

export default StickyBtn;
